export const OPINION_ON_PRICING = {
  question: "uninstall.survey.sub.opinionOnPricing.question",
  answers: [
    {
      id: 1,
      label: "uninstall.survey.sub.opinionOnPricing.answer.1",
    },
    {
      id: 2,
      label: "uninstall.survey.sub.opinionOnPricing.answer.2",
    }
  ]
}

export const WHAT_ASPECTS_HARD_TO_USE = {
  question: "uninstall.survey.sub.AspectsHardToUse.question",
  answers: [
    {
      id: 1,
      label: "uninstall.survey.sub.AspectsHardToUse.answer.1",
      showFurtherSurvey: true,
    },
    {
      id: 2,
      label: "uninstall.survey.sub.AspectsHardToUse.answer.2",
      showFurtherSurvey: true,
    }
  ],
  furtherSurveyQuestion: "uninstall.survey.sub.AspectsHardToUse.further.question"
}

export const WHAT_MISSING_FEATURE = {
  question: "uninstall.survey.sub.featureMissing.question",
  answers: [
    { 
      id: 1,
      label: "uninstall.survey.sub.featureMissing.answer.1",
      showFurtherSurvey: true,
    },
    { 
      id: 2,
      label: "uninstall.survey.sub.featureMissing.answer.2",
      showFurtherSurvey: true,
    },
    { 
      id: 3,
      label: "uninstall.survey.sub.featureMissing.answer.3",
      showFurtherSurvey: true,
    }
  ],
  furtherSurveyQuestion: "uninstall.survey.sub.featureMissing.further.question"
}

export const WHAT_TECHNICAL_ISSUES = {
  question: "uninstall.survey.sub.technicalIssue.question",
  answers: [
    {
      id: 1,
      label: "uninstall.survey.sub.technicalIssue.answer.1",
      showFurtherSurvey: true,
    },
    {
      id: 2,
      label: "uninstall.survey.sub.technicalIssue.answer.2",
      showFurtherSurvey: true,
    },
    {
      id: 3,
      label: "uninstall.survey.sub.technicalIssue.answer.3",
      showFurtherSurvey: true,
    },
    {
      id: 4,
      label: "uninstall.survey.sub.technicalIssue.answer.4",
      showFurtherSurvey: true,
      isRequired: true
    }
  ],
  furtherSurveyQuestion: "uninstall.survey.sub.technicalIssue.further.question"
}

export const WHAT_BUILDER_SWITCHING_TO = {
  question: "uninstall.survey.sub.builderSwitchingTo.question",
  answers: [
    { 
      id: 1,
      label: "uninstall.survey.sub.builderSwitchingTo.answer.1",
    },
    { 
      id: 2,
      label: "uninstall.survey.sub.builderSwitchingTo.answer.2",
    },
    { 
      id: 3,
      label: "uninstall.survey.sub.builderSwitchingTo.answer.3",
    },
    { 
      id: 4,
      label: "uninstall.survey.sub.builderSwitchingTo.answer.4",
    },
    { 
      id: 5,
      label: "uninstall.survey.sub.builderSwitchingTo.answer.5",
    },
    { 
      id: 6,
      label: "uninstall.survey.sub.builderSwitchingTo.answer.6",
      showFurtherSurvey: true,
      isRequired: true
    }
  ],
  furtherSurveyQuestion: "uninstall.survey.sub.builderSwitchingTo.further.question"
}

export const WHY_NOT_NEEDED = {
  question: "uninstall.survey.sub.whyNotNeeded.question",
  answers: [
    { 
      id: 1,
      label: "uninstall.survey.sub.whyNotNeeded.answer.1",
    },
    { 
      id: 2,
      label: "uninstall.survey.sub.whyNotNeeded.answer.2",
    },
    { 
      id: 3,
      label: "uninstall.survey.sub.whyNotNeeded.answer.3",
			showFurtherSurvey: true,
    },
    { 
      id: 4,
      label: "uninstall.survey.sub.whyNotNeeded.answer.4",
			showFurtherSurvey: true,
      isRequired: true
    }
  ],
	furtherSurveyQuestion: "uninstall.survey.sub.whyNotNeeded.further.question"
}
